import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Air8Label = _resolveComponent("Air8Label")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.dashboard_chart)
  }, [
    _createElementVNode("div", {
      ref: "chart",
      class: _normalizeClass(_ctx.$style.dashboard_chart__chart)
    }, null, 2),
    (_ctx.isEmpty)
      ? (_openBlock(), _createBlock(_component_Air8Label, {
          key: 0,
          class: "$style.dashboard_chart__empty",
          useEmptyImage: true,
          modelValue: undefined
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}